import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import styled from 'styled-components';

import { Link } from '@sorare/routing';
import { BodyM } from '@sorare/core/src/atoms/typography/index.tsx';
import { DumbPlayerAvatar } from '@sorare/core/src/components/player/DumbPlayerAvatar/index.tsx';
import { ANY_SPORT_PLAYERS_SLUG } from '@sorare/core/src/constants/__generated__/routes.ts';
import { useSportContext } from '@sorare/core/src/contexts/sport/index.ts';
import { useFormatAnyPosition } from '@sorare/core/src/lib/players';

import type { AnyPlayerDescription_anyPlayer } from './__generated__/index.graphql.ts';

const Root = styled.div`
  display: flex;
  gap: var(--unit);
`;
const StyledDumbPlayerAvatar = styled(DumbPlayerAvatar)`
  width: 48px;
  height: 48px;
`;

type Props = {
  player: AnyPlayerDescription_anyPlayer;
};

export const AnyPlayerDescription = ({ player }: Props) => {
  const formatPosition = useFormatAnyPosition();
  const { generateSportContextPath } = useSportContext();
  const {
    displayName,
    squaredPictureUrl,
    slug,
    sport,
    shirtNumber,
    activeClub,
  } = player;

  return (
    <Root>
      <StyledDumbPlayerAvatar
        name={displayName}
        avatarUrl={squaredPictureUrl}
      />
      <div>
        <Link
          to={generateSportContextPath(ANY_SPORT_PLAYERS_SLUG, {
            params: { slug },
            sport,
          })}
        >
          <BodyM bold>{displayName}</BodyM>
        </Link>
        <BodyM color="var(--c-nd-600)">
          {`${player.anyPositions.map(formatPosition).join(', ')} #${shirtNumber} | ${activeClub?.name}`}
        </BodyM>
      </div>
    </Root>
  );
};

AnyPlayerDescription.fragments = {
  anyPlayer: gql`
    fragment AnyPlayerDescription_anyPlayer on AnyPlayerInterface {
      slug
      sport
      displayName
      squaredPictureUrl
      anyPositions
      shirtNumber
      activeClub {
        slug
        name
      }
    }
  ` as TypedDocumentNode<AnyPlayerDescription_anyPlayer>,
};
